var _defs, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeWorkingPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9.91 17.38h3.35M24.86 9.44c0-2.76-2.24-5-5-5h-.07c-2.76 0-5 2.24-5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.75 27.72h-5.74v-5.96"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 36.94,
    cy: 27.72,
    r: 1.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M35.46 32.68c-2.04 2.95-5.5 4.81-9.35 4.64-5.95-.26-10.56-5.3-10.3-11.25.26-5.95 5.3-10.56 11.25-10.3 4.24.19 7.8 2.8 9.4 6.44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33.46 12.29a5.004 5.004 0 00-4.33-2.49H10.51c-2.76 0-5 2.24-5 5v11.92c0 2.76 2.24 5 5 5h1.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeWorkingPattern);
export default __webpack_public_path__ + "static/media/changeWorkingPattern.5ea443a8e9b4f65de02805cc0ea35c21.svg";
export { ForwardRef as ReactComponent };